// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__Fqr2K","description":"PatientConsentPreview_description__2dac_"};